<template>
    <div class="app-footer" :class="footerClasses">
        <layout-contained>
            <div class="py-6">
                <span class="text-gray-100">
                    &copy; {{ new Date().getFullYear() }}
                    {{ $config.public.companyNameLong }}
                    <span class="hidden md:inline">
                        | <NuxtLink class="hover:underline" to="/">Home</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/contact">Contact</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/privacy">Privacy</NuxtLink> |
                        <NuxtLink class="hover:underline" to="/cookies">Cookies</NuxtLink> | Website by
                        <a class="hover:underline" href="https://www.triplestep.tv/">Triple Step TV</a>
                    </span>
                </span>
                <div class="my-1 md:my-3">
                    <div class="text-gray-400 italic mb-5 md:mb-6 text-sm">Proud to partner with:</div>
                    <div class="max-w-sm pt-2 pb-4 pr-10 grid grid-cols-2 place-items-center gap-10">
                        <a class="block" href="https://dancelib.com/" target="_blank">
                            <img
                                loading="lazy"
                                class="w-full aspect-277/121"
                                :src="$config.public.images + 'dancelib.svg'"
                                alt="Dancelib"
                            />
                        </a>
                        <a class="block mr-3" href="https://www.triplestep.tv/">
                            <img
                                loading="lazy"
                                class="w-full aspect-240/82"
                                :src="$config.public.images + 'triple-step.png'"
                                alt="Triple Step TV"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    props: {
        color: {
            required: false,
            type: String,
            default: 'bg-zinc-900',
        },
    },
    computed: {
        footerClasses() {
            const cls = {};
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
